// extracted by mini-css-extract-plugin
export default {"asyncSuggestion":"shared-module__asyncSuggestion--lDyxK","stale":"shared-module__stale--IEVWo"};